module.exports = __webpack_public_path__ + "static/media/javascript.0484a8d2.svg";